export function getFileNameFromUrl(url = '') {
  return url
    .split('#')
    .shift()
    .split('?')
    .shift()
    .split('/')
    .pop();
}
